import { get } from 'lodash';

import { CHANNEL, REVIEWS_CHANNEL, WEBSITE_CHANNEL } from 'src/data/channel';

export const ADS_CHANNELS = [CHANNEL.google, CHANNEL.facebook, CHANNEL.linkedin];

export const REVIEWS_CHANNELS = [REVIEWS_CHANNEL.amazon, REVIEWS_CHANNEL.trustpilot];

export const WEBSITE_CHANNELS = [WEBSITE_CHANNEL.homepage, WEBSITE_CHANNEL.landingPages];

export const PERFORMANCE_CHANNELS = [...ADS_CHANNELS, ...REVIEWS_CHANNELS, ...WEBSITE_CHANNELS];

export const ACCOUNT_FIELD = {
  toggle: 'toggle',
  id: 'id',
  name: 'name',
  connectedState: 'connectedState',
};

export const COPY_FIELD = {
  text: 'text',
  textType: 'textType',
  keywords: 'keywords',
  tags: 'tags',
  startDate: 'startDate',
  sourceAnyword: 'sourceAnyword',
  numberOfInstances: 'numberOfInstances',
  impressions: 'impressions',
  weightedCtr: 'weightedCtr',
  campaignNames: 'campaignNames',
  improve: 'improve',
  lifetimeConversions: 'lifetimeConversions',
};

export const TALKING_POINT_FIELD = {
  talkingPoint: 'talkingPoint',
  rating: 'rating',
  impressions: 'impressions',
  numberOfInstances: 'numberOfInstances',
  tags: 'tags',
  textType: 'textType',
};

export const FILTER_ASSET_TYPE = {
  allAssets: 'all_assets',
  title: 'title',
  text: 'text',
};

const FILTER_ASSET_TYPE_PROPS = {
  [FILTER_ASSET_TYPE.allAssets]: {
    label: {
      [CHANNEL.google]: 'All asset type',
      [CHANNEL.facebook]: 'All asset type',
      [CHANNEL.linkedin]: 'All asset type',
      default: 'All asset type',
    },
  },
  [FILTER_ASSET_TYPE.title]: {
    label: {
      [CHANNEL.google]: 'Headline',
      [CHANNEL.facebook]: 'Headline',
      [CHANNEL.linkedin]: 'Headline',
      default: 'Headline',
    },
  },
  [FILTER_ASSET_TYPE.text]: {
    label: {
      [CHANNEL.google]: 'Description',
      [CHANNEL.facebook]: 'Primary text',
      [CHANNEL.linkedin]: 'Copy',
      default: 'Description',
    },
  },
};

export const getFilterAssetType = (filterAssetType, channel) =>
  get(FILTER_ASSET_TYPE_PROPS, [filterAssetType, 'label'])[channel || 'default'] || '';

export const INSIGHTS_INTERVAL_DAYS = {
  today: 'today',
  yesterday: 'yesterday',
  oneWeeks: 'one_weeks',
  allTime: 'all_time',
};

export const DEFAULT_INSIGHTS_INTERVAL_DAYS = INSIGHTS_INTERVAL_DAYS.allTime;

const INSIGHTS_INTERVAL_DAYS_PROPS = {
  [INSIGHTS_INTERVAL_DAYS.today]: {
    label: 'Published today',
    value: 0,
  },
  [INSIGHTS_INTERVAL_DAYS.yesterday]: {
    label: 'Published yesterday',
    value: 1,
  },
  [INSIGHTS_INTERVAL_DAYS.oneWeeks]: {
    label: 'Published in the last 7 days',
    value: 7,
  },
  [INSIGHTS_INTERVAL_DAYS.allTime]: {
    label: 'Published all time',
    value: null,
  },
};

export const getInsightsIntervalDaysLabel = (insightsIntervalDays) =>
  get(INSIGHTS_INTERVAL_DAYS_PROPS, [insightsIntervalDays, 'label']) || '';

export const getInsightsIntervalDaysValue = (insightsIntervalDays) =>
  get(INSIGHTS_INTERVAL_DAYS_PROPS, [insightsIntervalDays, 'value']);

export const getInsightsIntervalDaysByValue = (value) =>
  Object.values(INSIGHTS_INTERVAL_DAYS).find(
    (insightsIntervalDays) => value === getInsightsIntervalDaysValue(insightsIntervalDays)
  );

export const CIP_TAG_STATUS = {
  suggestion: 'suggestion',
  accepted: 'accepted',
  userAdded: 'user_added',
  rejected: 'rejected',
};

export const CIP_TAG_ACTION_TYPE = {
  custom: 'custom',
  accept: 'accept',
  rejectOne: 'reject_one',
  rejectForever: 'reject_forever',
};

export const CIP_MAX_TAGS = 20;

export const CIP_ADS_PER_PAGE = 25;
